import { Heading } from '@components/gassan-ui/Typography/Heading'
import { useTranslation } from 'next-i18next'
import { FC } from 'react'
import { cn } from '@lib/cn'

const iconKeys: ['free-delivery', 'personal-advice', 'free-returns', 'always-insured'] = [
  'free-delivery',
  'personal-advice',
  'free-returns',
  'always-insured',
]

const icons = {
  'free-delivery': [
    '/images/appointment-block/free_delivery_mobile.svg',
    '/images/appointment-block/free_delivery_desktop.svg',
  ],
  'personal-advice': [
    '/images/appointment-block/personal_advice_mobile.svg',
    '/images/appointment-block/personal_advice_desktop.svg',
  ],
  'free-returns': [
    '/images/appointment-block/free_returns_mobile.svg',
    '/images/appointment-block/free_returns_desktop.svg',
  ],
  'always-insured': [
    '/images/appointment-block/always_insured_mobile.svg',
    '/images/appointment-block/always_insured_desktop.svg',
  ],
}

const USPs: FC = () => {
  const { t } = useTranslation('global')
  return (
    <div
      className={cn(
        'mb-12 grid grid-cols-2 items-start justify-between justify-items-center gap-10',
        'sm:flex',
        'lg:mb-14',
        '[&_[data-heading]]:text-current',
      )}
    >
      {iconKeys.map((icon, index) => (
        <div
          className={cn(
            'flex max-w-[160px] flex-col items-center justify-center text-center text-tabaccoBrown',
          )}
          key={index}
        >
          <div className={cn('block', 'sm:hidden')}>
            <img src={icons[icon][0]} alt={icon} className="max-w-[50px]" />
          </div>
          <div className={cn('hidden', 'sm:block')}>
            <img src={icons[icon][1]} alt={icon} className="max-w-[50px]" />
          </div>
          <Heading
            variant="h5"
            as="span"
            className="mb-0"
            data-heading
            dangerouslySetInnerHTML={{
              __html: t(`${icon}`),
            }}
          ></Heading>
        </div>
      ))}
    </div>
  )
}

export default USPs
